import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AppState } from '@app/types/app.types';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take, filter as rxjsFilter } from 'rxjs/operators';
import { RouteAccessService } from './route-access.service';

@Injectable({
  providedIn: 'root',
})
export class ScreenAccessGuardService implements CanActivate {
  constructor(
    private store: Store<AppState>,
    private router: Router,
    private routeAccessService: RouteAccessService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const requiredAccess = route.data['screenAccess'] as string[];
    return this.store.pipe(
      select((appState: any) => appState.app.screenAccessState),
      rxjsFilter((screenAccess) => screenAccess !== null && screenAccess !== undefined && screenAccess.length > 0),
      take(1), // Take the first valid emission
      map((userScreenAccess: string[]) => {
        if (!requiredAccess || requiredAccess.length === 0) {
          return true;
        }

        const hasAccess = requiredAccess.some(
          (access) => userScreenAccess.includes(access) || userScreenAccess.includes('ALL'),
        );

        if (hasAccess) {
          return true;
        } else {
          console.warn(
            `Access denied for route: ${state.url}. Required: ${requiredAccess}, User has: ${userScreenAccess}`,
          );
          // Instead of always redirecting to '/', find the first accessible route
          // Create a shallow copy of userScreenAccess before sorting
          const sortedUserScreenAccess = [...userScreenAccess].sort();
          const firstAccessibleRoute = this.routeAccessService.findFirstAccessibleRoute(sortedUserScreenAccess[0]);
          if (firstAccessibleRoute) {
            return this.router.createUrlTree([firstAccessibleRoute]);
          } else {
            // If no accessible routes, redirect to a generic "Access Denied" page or '/' as a last resort
            return this.router.createUrlTree(['/access-denied']); // Create a dedicated component for this
          }
        }
      }),
    );
  }
}
